/* eslint no-underscore-dangle: 0 */
import '@babel/polyfill';
import 'regenerator-runtime/runtime';

import React from 'react';
import { render } from 'react-dom';
import Amplify from '@aws-amplify/core';

import './styles/book.less';

import amplifyConfig from './amplifyConfig';
import { initTelemetry } from './lib/telemetry';
import { identify } from './utils/browser';
import { installBugsnagNetworkNoiseFilter } from './utils/bugsnagNetworkNoise';
import routes from './routes/book';
import Root from './containers/Root';
import { store, history } from './store';

// OTEL-6: before render and before the boot-time fetch fan-out, so instrumentation-fetch is
// already patched when the first API call goes out. No-op when no OTLP endpoint is configured.
initTelemetry(routes);
identify();
// MS-6583: gate network-level fetch failures (navigation aborts, offline blips) before they
// reach Bugsnag — installed before render so the boot-time fetch fan-out is already covered.
installBugsnagNetworkNoiseFilter(window);

Amplify.configure(amplifyConfig);

render(
  <Root store={store} history={history} routes={routes} />,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/book.jsx